module.exports = __webpack_public_path__ + "images/twitter@3x.png?45a3e0a4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/twitter@3x.png
// module id = 712
// module chunks = 7